The identifier for the `PositionProfile`.

Scheme restrictions:

- The `seekAnz` scheme creates the position profile asynchronously.
  This identifier will initially reference a missing object;
  the object should be created within a few minutes.
